import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { Balance } from "src/app/shared/models/balances";
import { Company } from "src/app/shared/models/companies";
import { BalancesService } from "src/app/shared/services/balances.service";
import { CompaniesService } from "src/app/shared/services/companies.service";
import { UtilitiesService } from "src/app/shared/services/utilities.service";
import { ProgramsService } from "src/app/shared/services/programs.service";
import { Level } from "../../shared/enums/level.enum";
import { Invoice } from "src/app/shared/models/invoice";
import { environment } from "../../../environments/environment";
import * as _ from "lodash";

@Component({
  selector: "app-balances",
  templateUrl: "./balances.component.html",
  styleUrls: ["./balances.component.scss"],
})
export class BalancesComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  balances: Balance[];
  companies: Company[];
  popupVisible = false;
  newBalanceEntry: any = {};
  usdt: any;
  id_companies_list: any[] = [];
  disableBalanceBtn = true;
  visibleBalanceBtn = false;
  isVisibleBalanceBtn = false;
  isVisibleInvoiceBtn = false;
  invoicesAvailibles = 'Habilitar facturas';

  constructor(
    private balancesService: BalancesService,
    private utilitiesService: UtilitiesService,
    private companiesService: CompaniesService,
    private programsService: ProgramsService
  ) {
    this.usdt = this.utilitiesService.getUserData();
    switch (this.usdt.level) {
      case Level.ihunterSuperUser:
      case Level.ihunterAdmin:
      case Level.ihunterReportes:
        this.disableBalanceBtn = false;
        this.visibleBalanceBtn = true;
        this._subscriptions.push(
          this.companiesService.getCompanies().subscribe((companies) => {
            this.companies = companies;
          }),
          this.balancesService.getBalances().subscribe((balances) => {
            this.balances = balances;
          })
        );
        break;
      case Level.CompanyAdmin:
        this.disableBalanceBtn = false;
        this.visibleBalanceBtn = true;
        break;
      case Level.CompanyAdmin:
      case Level.CompanyUser:
      case Level.CompanyReportes:
        this._subscriptions.push(
          this.companiesService.getCompanies().subscribe((companies) => {
            this.companies = companies.filter(
              (company) => company.id == this.usdt.companyId
            );
          }),
          this.balancesService.getBalances().subscribe((balances) => {
            this.balances = balances.filter(
              (balance) => balance.companyId == this.usdt.companyId
            );
          })
        );
        break;
      case Level.Broker:
        if (this.usdt.companyList) {
          this.usdt.companyList.forEach((company) => {
            this.id_companies_list.push(company.id.trim());
          });
        }
        this._subscriptions.push(
          this.companiesService.getCompanies().subscribe((companies) => {
            this.companies = companies.filter((company) =>
              this.id_companies_list.includes(company.id)
            );
          }),
          this.balancesService.getBalances().subscribe((balances) => {
            this.balances = balances.filter((balance) =>
              this.id_companies_list.includes(balance.companyId)
            );
          })
        );
      default:
        break;
    }
  }

  ngOnInit() {}

  newBalance() {
    this.popupVisible = true;
    this.newBalanceEntry = {
      date: this.utilitiesService.dateToNumber(new Date()),
      deposit: null,
      conceptId: 1,
      conceptName: null,
      transactionId: null,
      dispersionId: null,
      companyId: null,
    };
  }
  isCreatInvove(e) {
    this.isVisibleInvoiceBtn = !this.isVisibleInvoiceBtn;
  }

  addNewBalance(data) {
    if (data.validationGroup.validate().isValid) {
      this.isVisibleBalanceBtn = true;
      const companyId = this.newBalanceEntry.companyId;
      this.companiesService.getCompany(companyId).subscribe((company) => {
        this.programsService
          .getProgram(company.programs[0].programId)
          .subscribe((program) => {
            var invoice = new Invoice();
            var mount = this.newBalanceEntry.deposit;
            var fees =
              this.newBalanceEntry.deposit *
              program.companyCosts.dispersionCost;
              fees = parseFloat(fees.toFixed(2));
            var tax = fees * 0.16;
            tax = parseFloat(tax.toFixed(2));
            var granTotal = parseFloat(this.newBalanceEntry.deposit.toFixed(2)) + fees + tax;
            invoice.Currency = "MXN";
            invoice.ExpeditionPlace = environment.expeditionPlace;
            invoice.PaymentConditions = "Contado";
            invoice.CfdiType = "I";
            invoice.PaymentForm = "03";
            invoice.PaymentMethod = "PUE";
            invoice.Receiver.Rfc = company.rfc;
            invoice.Receiver.Name =
              company.companyLegalName +
              " - " +
              company.address.street +
              " " +
              company.address.number +
              " " +
              company.address.city +
              " " +
              company.address.state +
              " " +
              company.address.neighborhood +
              " " +
              company.address.zip +
              " ";
            invoice.Receiver.CfdiUse = "P01";
            invoice.Items = [
              {
                ProductCode: null,
                IdentificationNumber: null,
                Description: null,
                Unit: null,
                UnitCode: null,
                UnitPrice: null,
                Quantity: null,
                Subtotal: null,
                Total: null,
                Taxes: [
                  {
                    Total: null,
                    Name: null,
                    Base: null,
                    Rate: null,
                    IsRetention: null,
                  },
                ],
              },
            ];
            invoice.Items[0].ProductCode = "80141600" // codigo de productos (Servicios) 80141600 Actividades de negocios negocios
            invoice.Items[0].IdentificationNumber = "EDL";
            var totalDispersion = parseFloat(
              (granTotal - (tax + fees)).toString()
            ).toFixed(2);
            invoice.Items[0].Description =
              "Comisión por recarga en tarjetas mastercard - CANTIDAD DISPERSADA " +
              "$" +
              totalDispersion;
            invoice.Items[0].Unit = " Unidad  de servicio";
            invoice.Items[0].UnitCode = "E48";
            var UnitPrice = fees;
            invoice.Items[0].UnitPrice = UnitPrice;
            invoice.Items[0].Quantity = 1;
            var Subtotal = fees;
            invoice.Items[0].Subtotal = Subtotal;
            var total = tax + fees;
            invoice.Items[0].Total = parseFloat(total.toFixed(2));
            invoice.Items[0].Taxes[0].Total = tax;
            invoice.Items[0].Taxes[0].Name = "IVA";
            var Base = fees;
            invoice.Items[0].Taxes[0].Base = Base;
            invoice.Items[0].Taxes[0].Rate = 0.16;
            invoice.Items[0].Taxes[0].IsRetention = false;
            var companyBalance = this.balances.filter(
              (balance) => balance.companyId === this.newBalanceEntry.companyId
            );
            console.log(invoice);
            if (this.isVisibleInvoiceBtn) {
              this.utilitiesService.createInvoice(invoice).subscribe(
                (newInvoice) => {
                  const balanceId = companyBalance[0].id;
                  delete this.newBalanceEntry.companyId;

                  companyBalance[0].transactions = [];
                  companyBalance[0].transactions.push(this.newBalanceEntry);
                  companyBalance[0].balance += this.newBalanceEntry.deposit;
                  companyBalance[0].idInvoice = newInvoice.Id;

                  invoice.idInvoice = newInvoice.Id;
                  invoice.nameProgram = program.name;
                  invoice.Fees = fees;
                  invoice.Tax = tax;
                  invoice.Total = granTotal;
                  invoice.Mount = mount;
                  invoice.dateCreated = this.utilitiesService.dateToNumber(
                    new Date()
                  );
                  invoice.companyId = company.id;
                  invoice.companyName = company.companyName;

                  this.utilitiesService
                    .setInvoice(invoice)
                    .then((resultInvoice) => {
                      console.log("factura registrada exitosamente");
                      this.isVisibleBalanceBtn = false;
                    });

                  this.balancesService
                    .updateBalance(balanceId, companyBalance[0])
                    .then((entry) => {
                      this.utilitiesService.notifyMe(
                        "Balance agregado al cliente",
                        "success"
                      );
                      this.popupVisible = false;
                    })
                    .catch((error) => console.log(error)); 
                },
                (error) => {
                  this.utilitiesService.notifyMe(
                    error.error.ModelState["cfdiToCreate.Receiver.Rfc"][0],
                    "error"
                  );
                }
              );
            }else{
              companyBalance[0].transactions = [];
              companyBalance[0].transactions.push(this.newBalanceEntry);
              companyBalance[0].balance += this.newBalanceEntry.deposit;
              console.log(companyBalance[0]);
              this.balancesService
              .updateBalance(companyBalance[0].id, companyBalance[0])
              .then((entry) => {
                this.utilitiesService.notifyMe(
                  "Balance agregado al cliente",
                  "success"
                );
                this.popupVisible = false;
              })
              .catch((error) => console.log(error));
            }
          });
      });
    }
  }

  cancelBalance() {
    this.popupVisible = false;
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }
}
